import React from 'react';

const SingleWhiteSpace = () => <>{'\u00A0'}</>;

export default SingleWhiteSpace;